import { ReactNode } from 'react';
import { View, StyleSheet, ScrollView, Image } from 'react-native';
import { theme, Text } from '@socrait/react';

import { HyperLink } from '~/components/HyperLink';
import { handlePrivacyPolicyPress, handleTermsOfServicePress } from '~/constants';
import socraitLogoHeaderUrl from '~/assets/images/socrait_logo_header.svg';

interface PublicPageLayoutProps {
  children: ReactNode;
}

export function PublicPageLayout({ children }: PublicPageLayoutProps) {
  return (
    <ScrollView
      style={styles.scrollContainer}
      contentContainerStyle={styles.outerContainer}
      showsVerticalScrollIndicator={false}>
      <View style={styles.headerRow}>
        <Image source={{ uri: socraitLogoHeaderUrl }} style={styles.logoHeader} resizeMode="contain" />
      </View>
      {children}
      <View style={styles.footer}>
        <Text style={styles.footerText}>
          <HyperLink onPress={handleTermsOfServicePress} variant="subdued" style={styles.footerLink}>
            Terms and Conditions
          </HyperLink>
          {' | '}
          <HyperLink onPress={handlePrivacyPolicyPress} variant="subdued" style={styles.footerLink}>
            Privacy Policy
          </HyperLink>
          {'  /  2026 © All Rights Reserved'}
        </Text>
      </View>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollContainer: {
    flex: 1,
    backgroundColor: theme.colors.white,
  },
  outerContainer: {
    flexGrow: 1,
    flexDirection: 'column',
  },
  headerRow: {
    paddingHorizontal: theme.spacing.xxlarge,
    paddingVertical: theme.spacing.xlarge,
  },
  logoHeader: {
    height: 31,
    width: 150,
  },
  footer: {
    backgroundColor: theme.colors.navy,
    padding: theme.spacing.xlarge,
    marginTop: theme.spacing.xlarge * 2,
    alignItems: 'center',
  },
  footerText: {
    fontSize: theme.fontSizes.xsmall,
    color: theme.colors.white,
    textAlign: 'center',
    fontFamily: theme.fonts.regular,
  },
  footerLink: {
    color: theme.colors.white,
    fontSize: theme.fontSizes.xsmall,
    textDecorationLine: 'underline',
  },
});
